<template>
  <div>
    <info-mobile :info="details.group_name" title="Group Name" class="pt-2" />
    <info-mobile
      select
      :info="details.interface"
      :items="_interfaceTypes"
      title="Interface"
      :cols="[5, 7]"
    />
    <info-mobile
      :info="details.uuid ? details.uuid : ''"
      title="Unique ID"
      :cols="[5, 7]"
    />
    <info-mobile
      :info="details.contact ? details.contact.contact_name : ''"
      title="Contact Name"
    />
    <info-mobile
      :info="formatPhone(details.contact ? details.contact.phone : '')"
      title="Phone"
      :cols="[5, 7]"
    />
    <info-mobile
      :info.sync="details.vistar_direct"
      title="vistar_direct"
      id="group-vistar-direct"
      :cols="3"
      select
      vistar
      :items="vistarOptions"
    />
    <info-mobile
      :readOnly="true"
      :info.sync="details.code"
      title="Group Code"
      id="group-contact-name"
      :cols="3"
    />
    <info-mobile
      :info="
        details.status
          ? details.status.charAt(0).toUpperCase() + details.status.slice(1)
          : ''
      "
      title="Status"
      :cols="[5, 7]"
    />
    <info-mobile :info="details.ad_schedule" title="Ad Schedule" />
    <info-mobile :info="area ? area.text : ''" title="Area" />
    <info-mobile :info="formatedAddress" title="Address" :cols="[5, 7]" />
    <info-mobile :info="details.inventory" title="Inventory" />
    <info-mobile
      :info="computedUtilization"
      title="High Utilization Trigger"
      :cols="[8, 4]"
    />
    <info-mobile
      :info="details.contact ? details.contact.email : ''"
      title="Email"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import InfoMobile from '@/components/group-details/InfoMobile';
import GroupDetailData from '@/mixins/GroupDetailData';
import FormatPhone from '@/mixins/FormatPhone';

export default {
  data() {
    return {
      vistarOptions: [
        { text: 'No Vistar', value: 0 },
        { text: 'Vistar Normal', value: 1 },
        { text: 'Vistar Direct', value: 2 },
      ],
    };
  },
  components: {
    InfoMobile,
  },
  mixins: [GroupDetailData, FormatPhone],
  computed: {
    ...mapGetters({
      _areas: 'areas/getAreas',
      _client: 'account/getCurrentClient',
      _interfaceTypes: 'groupDetails/getInterfaceTypes',
    }),
    computedUtilization: {
      get() {
        return this.details.tablet_settings
          && this.details.tablet_settings.utilization_trigger
          ? `${this.details.tablet_settings.utilization_trigger.toString()}%`
          : '';
      },
      set(val) {
        this.details.tablet_settings.utilization_trigger = parseInt(
          val.replace(/^\D+/g, ''),
        );
      },
    },
    formatedAddress() {
      return this.details.address
        ? `${this.details.address.address_1}, ${this.details.address.city}`
        : '';
    },
    phone: {
      get() {
        return this.formatPhone(
          this.details.contact ? this.details.contact.phone : '',
        );
      },
      set(val) {
        this.details.contact.phone = val;
      },
    },
    contactName: {
      get() {
        return this.details.contact ? this.details.contact.contact_name : '';
      },
      set(val) {
        this.details.contact.contact_name = val;
      },
    },
    email: {
      get() {
        return this.details.contact ? this.details.contact.email : '';
      },
      set(val) {
        this.details.contact.email = val;
      },
    },
    status() {
      return this.details.status
        ? this.details.status.charAt(0).toUpperCase()
            + this.details.status.slice(1)
        : '';
    },
    area: {
      get() {
        return this._areas.find((area) => area.value === this.details.area_id);
      },
      set(val) {
        this.details.area_id = val;
      },
    },
  },
};
</script>
